module.exports = __webpack_public_path__ + "static/media/APO - Trumper.9bbe0343.pdf";